// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class EnrollmentMedBenClientIdentifiersModel {
    static getAttributeTypeMap() {
        return EnrollmentMedBenClientIdentifiersModel.attributeTypeMap;
    }
}
EnrollmentMedBenClientIdentifiersModel.discriminator = undefined;
EnrollmentMedBenClientIdentifiersModel.additionalProperties = false;
EnrollmentMedBenClientIdentifiersModel.attributeTypeMap = [
    {
        "name": "sites",
        "baseName": "sites",
        "type": ""
    },
    {
        "name": "sourceId",
        "baseName": "sourceId",
        "type": "TCSSource"
    },
    {
        "name": "alternateId",
        "baseName": "alternateId",
        "type": "string"
    },
    {
        "name": "alternateIdType",
        "baseName": "alternateIdType",
        "type": "string"
    },
];
//# sourceMappingURL=enrollmentMedBenClientIdentifiersModel.js.map